module.exports = __webpack_public_path__ + "static/media/ayush.9d16fd12.jpeg";